import * as server from "@/utils/http"

export const _page = params => server.get("/resident/page", params);
export const _get = params => server.get("/resident/get", params);
export const _updateStatus = params => server.get("/resident/updateStatus", params);
export const _save = params => server.postfrom(params.id ? "/resident/update" : "/resident/save", params);

